import { isServer, html } from 'lit';
import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';
import { trustedCSS } from '../../lib/css/css.js';
import { getCrntElementsFromString, whenCrntElementsAreDefined } from '../../lib/when-crnt-elements-are-defined.js';
import componentLoaderStyles from './component-loader.css.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntComponentLoader extends CrntElement {
  constructor() {
    super(...arguments);
    this.animation = "none";
    this.defined = false;
    this.timeout = 500;
  }
  static {
    this.styles = trustedCSS(componentLoaderStyles);
  }
  static {
    this.tagName = "crnt-component-loader";
  }
  connectedCallback() {
    super.connectedCallback();
    if (isServer) {
      this.defined = true;
    } else {
      const tags = getCrntElementsFromString(document.documentElement.innerHTML);
      whenCrntElementsAreDefined(tags, this.timeout).then(() => {
        this.defined = true;
      });
    }
  }
  render() {
    return html`<slot></slot>`;
  }
}
__decorateClass([
  property({ reflect: true })
], CrntComponentLoader.prototype, "animation");
__decorateClass([
  property({ reflect: true, type: Boolean })
], CrntComponentLoader.prototype, "defined");
__decorateClass([
  property({ reflect: true, type: Number })
], CrntComponentLoader.prototype, "timeout");

export { CrntComponentLoader };
